import { Button, Checkbox } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ContentOverlay } from 'src/Containers/ContentOverlay';
import { useAcceptTermsForm } from 'src/Hooks/Forms/useAcceptTermsForm';
import { useAcceptTerms } from 'src/Hooks/Mutations/useAcceptTerms';

import styles from './AcceptTermsForm.module.scss';

const AcceptTermsForm = () => {
  const { t } = useTranslation();
  const form = useAcceptTermsForm();

  const termsOfServiceUrl = import.meta.env.VITE_TERMS_OF_SERVICE_URL;
  const privacyPolicyUrl = import.meta.env.VITE_PRIVACY_POLICY_URL;

  const navigate = useNavigate();
  const { mutate, isLoading } = useAcceptTerms({ onSuccess: () => navigate('/') });
  return (
    <ContentOverlay>
      <div className={styles.container}>
        <form onSubmit={form.onSubmit(values => mutate(values))} className={styles.form}>
          <div className={styles.subcontainer}>
            <div>
              <p className={styles.title}>
                {t('acceptTermsForm.title', '✅ Acceptez les conditions avant de continuer')}
              </p>
            </div>
            <Checkbox
              label={
                <>
                  {t('acceptTermsForm.acceptTermsPrivacy', "J'ai lu et j'accepte les ")}
                  <a
                    href={termsOfServiceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.checkboxLabel}
                    onClick={e => e.stopPropagation()}
                  >
                    {t('acceptTermsForm.termsOfUse', "Conditions d'Utilisation")}{' '}
                  </a>
                  {t('acceptTermsForm.and', ' et la ')}
                  <a
                    href={privacyPolicyUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.checkboxLabel}
                    onClick={e => e.stopPropagation()}
                  >
                    {t('acceptTermsForm.privacyPolicy', 'Politique de Confidentialité')}
                  </a>
                  .
                </>
              }
              className={styles.checkboxMargin}
              {...form.getInputProps('acceptedTermsPrivacy', { type: 'checkbox' })}
            />
            <Checkbox
              label={
                <div className={styles.checkboxLabel}>
                  {t(
                    'acceptTermsForm.newsletterOptIn',
                    'Je souhaite recevoir des informations et offres commerciales par e-mail.'
                  )}
                </div>
              }
              className={styles.checkboxMargin}
              {...form.getInputProps('newsletterOptIn', { type: 'checkbox' })}
            />
            <Button variant="filled" type="submit" loading={isLoading} disabled={isLoading}>
              {t('acceptTermsForm.continue', 'Continuer')}
            </Button>
          </div>
        </form>
      </div>
    </ContentOverlay>
  );
};

export default AcceptTermsForm;
